export default "__VITE_ASSET__CMnvBTAC__"